import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import { PMSimpleSelectorField } from "../PMSimpleSelector/PMSimpleSelectorField";
import { PMSimpleSelectorFieldV2 } from "../PMSimpleSelector/PMSimpleSelectorFieldV2";
import axios from "../../../api/axios";
import { useState, useEffect } from "react";
import { mapErrors } from "../../Utils";
import { Form, Formik } from "formik";
import { ResourceLoading } from "../ResourceLoading";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { PMField } from "../PMField";
import { COUNTRY_OPTIONS, DEFAULT_COUNTRY } from "../../../constants/countries";
import { PMDialog } from "../PMDialog";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

export const DeliveryAddressSelector = (props) => {
  const {
    setFieldValue,
    values,
    onChange,
    errors,
    module,
    module_param,
    fields,
  } = props;

  const name = "delivery_address_id";
  const label = props.label ? props.label : "Delivery Address";
  const itemDisplayLabel = "address";
  const numberField = null;
  const FETCH_URL = "/delivery_addresses/";
  const CREATE_URL = "/delivery_addresses/";
  // const filters = [{ name: module, value: module_param }];
  const filters = [];

  const { t } = useTranslation();

  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({
    id: 0,
    field1: "Ingen valgt",
    field2: null,
  });
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editLoading, setEditLoading] = useState(false);

  const labelAction = {
    // action: () => toast("test"),
  };

  const handleChange = (data) => {
    setLoading(false);
    setSelected({
      id: data?.selected?.item?.value,
      field1: data?.selected?.item?.primary,
    });
    setOpen(false);
    props.onSelectedItemChange?.({ id: data.selected.item.id, displayTitle: data.selected.item.primary });
    if (values) {
      setFieldValue(name, data.selected.item.id);
    } else {
      onChange({ target: { name: name, value: data.selected.item.id } });
    }
  };

  const handleSelectFromForm = (data) => {
    props.onSelectedItemChange?.(data);
    setSelected({
      id: data?.id,
      field1: data?.displayTitle,
    });
    if (values) {
      setFieldValue(name, data?.id);
    } else {
      onChange({ target: { name: name, value: data?.id } });
    }
  };

  const createView = (item) => {
    const createOrUpdate = (values) => {
      const data = {
        ...values,
        module: module,
        module_param: module_param,
      };
      if (values?.id) {
        return axios.put(`${FETCH_URL}${values.id}`, { delivery_address: data });
      }
      return axios.post(CREATE_URL, { delivery_address: data });
    };

    return (
      <>
        {loading ? (
          <ResourceLoading />
        ) : (
          <Formik
            enableReinitialize
            initialValues={{
              id: item?.id || null,
              name: item?.name ? item?.name : fields?.name ? fields?.name : "",
              address: item?.address
                ? item?.address
                : fields?.address
                ? fields?.address
                : "",
              address2: item?.address2
                ? item?.address2
                : fields?.address2
                ? fields?.address2
                : "",
              postal: item?.postal
                ? item?.postal
                : fields?.postal
                ? fields?.postal
                : "",
              place: item?.place
                ? item?.place
                : fields?.place
                ? fields?.place
                : "",
              country: item?.country
                ? item?.country
                : fields?.country
                ? fields?.country
                : DEFAULT_COUNTRY,
              submit: null,
            }}
            validationSchema={Yup.object({
              name: Yup.string().required(t("Name is required")),
              address: Yup.string().required(t("Address is required")),
              postal: Yup.string().required(t("Postal is required")),
              place: Yup.string().required(t("Place is required")),
              country: Yup.string().required(
                t("delivery_address.country_required")
              ),
            })}
            onSubmit={(values, helpers) => {
              try {
                toast.promise(createOrUpdate(values), {
                  loading: t("Saving...."),
                  success: (data) => {
                    if (data.status === 500) throw new Error("Server error");
                    if (data.status === 400) throw new Error("Server error");
                    if (data.data.errors)
                      throw new Error(mapErrors(data.data.errors));
                    // props.onRefresh(data.payload);
                    getItems();

                    if (data?.data?.id) {
                      handleSelectFromForm(data?.data);
                      setOpen(false);
                      setEditOpen(false);
                      setEditItem(null);
                    }

                    return t("Data was saved!");
                  },
                  error: (error) => {
                    return t("Something went wrong. Could not save data!");
                  },
                });
                helpers.setStatus({ success: true });
                helpers.setSubmitting(false);
              } catch (err) {
                toast.error("Something went wrong...");
                console.error(err);
                helpers.setStatus({ success: false });
                helpers.setErrors({ submit: err.message });
                helpers.setSubmitting(false);
              }
            }}
          >
            {(formik) => (
              <Form>
                <div className="grid grid-cols-6 gap-6">
                  <div className="col-span-6 sm:col-span-6">
                    <PMField
                      name="name"
                      type="text"
                      label={t("Name")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-6">
                    <PMField
                      name="address"
                      type="text"
                      label={t("Address")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-6">
                    <PMField
                      name="address2"
                      type="text"
                      label={t("Address 2")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-2">
                    <PMField
                      name="postal"
                      type="text"
                      label={t("Postal")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-4">
                    <PMField
                      name="place"
                      type="text"
                      label={t("Place")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-6">
                    <label className="mb-1 block text-sm font-semibold text-slate-700">
                      {t("delivery_address.country")}
                    </label>
                    <select
                      name="country"
                      value={formik.values.country || DEFAULT_COUNTRY}
                      onChange={formik.handleChange}
                      className="w-full rounded-[14px] border-[1.5px] border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900"
                    >
                      {COUNTRY_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.country && formik.touched.country ? (
                      <p className="mt-1 text-sm text-red-600">
                        {formik.errors.country}
                      </p>
                    ) : (
                      <p className="mt-1 text-xs text-slate-500">
                        {t("delivery_address.country_hint")}
                      </p>
                    )}
                  </div>
                </div>

                <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button
                    type="button"
                    className="inline-flex align-right justify-center rounded-md border border-transparent bg-emerald-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                    onClick={formik.submitForm}
                  >
                    {item?.id ? t("update") : t("create")}{" "}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </>
    );
  };

  const getItem = (id) => {
    return axios({ method: "get", url: FETCH_URL + id })
      .then((res) => {
        if (res.data.id) {
          setLoading(false);
          setSelected({
            id: res.data?.id,
            field1: res.data.displayTitle,
          });
        }
      })
      .catch((err) => {
        let errors = null;
        if (err?.data?.errors) {
          errors = mapErrors(err.data.errors);
        } else {
          errors = ["Something went wrong"];
        }
        setLoading(false);
      });
  };

  const getItems = () => {
    setLoading(true);
    const params = {
      query: query ? query : "",
      page: 1,
      sortBy: "created_at",
      sort: "desc",
      filters: filters,
      view: null,
    };

    return axios({ method: "get", url: FETCH_URL, params: params })
      .then((response) => {
        if (response.data.data) {
          var array = [
            { id: null, value: 0, primary: "Ingen valgt", secondary: null },
          ];
          if (!response.data.data) return array;
          response.data.data.map((row, i) => {
            const rowParams = {
              value: row.id,
              id: row.id,
              primary: row.name,
              secondary:
                [row.address, row.postal, row.place, row.country]
                  .filter(Boolean)
                  .join(", "),
              object: row,
            };
            array.push(rowParams);
          });
          setItems(array);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        return error.response.data;
      });
  };

  const debouncedAction = debounce((controller) => {
    getItems();
  }, 500);

  useEffect(() => {
    if (open) {
      debouncedAction();
    }

    // Clean the debounced function on component unmount.
    return () => {
      debouncedAction.cancel();
    };
  }, [query, open]);

  useEffect(() => {
    if (props?.selected?.id) {
      setSelected({
        id: props.selected?.id,
        field1: props.selected?.displayTitle
          ? props.selected?.displayTitle
          : "Missing title",
      });
    } else {
      setSelected({
        id: null,
        field1: "Ingen valgt",
        field2: null,
      });
    }
  }, [props.selected]);

  const openEdit = async (id, fallback) => {
    if (!id) return;
    setEditLoading(true);
    setEditOpen(true);
    setEditItem(fallback || { id });
    try {
      const res = await axios.get(FETCH_URL + id);
      if (res?.data?.id) setEditItem(res.data);
    } catch (err) {
      toast.error(t("delivery_address.edit_load_error"));
      setEditOpen(false);
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <>
      <div className="flex items-end gap-2">
        <div className="min-w-0 flex-1">
          <PMSimpleSelectorFieldV2
            errors={errors}
            name={name}
            loading={loading}
            label={t(label)}
            labelAction={labelAction}
            options={items}
            selected={selected}
            onChange={handleChange}
            onQueryChange={(query) => setQuery(query)}
            createView={createView}
            onEditItem={(item) => openEdit(item.id, item.object)}
            onClose={() => setOpen(!open)}
            open={open}
            zIndex={props.zIndex}
            fields={[
              {
                name: "name",
                label: "Name",
                type: "text",
                required: true,
                disabled: true,
              },
            ]}
          />
        </div>
        {selected?.id ? (
          <button
            type="button"
            onClick={() => openEdit(selected.id, props.selected)}
            className="mb-0.5 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[14px] border-[1.5px] border-slate-200 bg-white text-slate-600 hover:border-[#1463C7] hover:text-[#1463C7]"
            aria-label={t("delivery_address.edit")}
            title={t("delivery_address.edit")}
          >
            <PencilSquareIcon className="h-5 w-5" />
          </button>
        ) : null}
      </div>

      <PMDialog
        open={editOpen}
        onClose={() => {
          setEditOpen(false);
          setEditItem(null);
        }}
        title={t("delivery_address.edit_title")}
        size="lg"
        zIndex={(props.zIndex || 2500) + 50}
      >
        <div className="p-4">
          {editLoading && !editItem?.name ? (
            <ResourceLoading />
          ) : (
            createView(editItem)
          )}
        </div>
      </PMDialog>
    </>
  );
};
